module.exports = __webpack_public_path__ + "static/media/placeholder-image.fae87c92.svg";